<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-24
    	描述：商品评价
    -->
  <div class="product">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">

        <el-form-item label="动态">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入动态"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button  size="small" v-if="showBack" type="info" @click="gotoBack">返回上一页</el-button>
      
        </el-form-item>
      </el-form>
    </div>

    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部评价" name="-1"></el-tab-pane>
        <el-tab-pane label="待审核" name="0"></el-tab-pane>
        <el-tab-pane label="审核通过" name="1"></el-tab-pane>
        <el-tab-pane label="审核未通过" name="2"></el-tab-pane>
      </el-tabs>
    </template>
    <div class="operaction" style="display: flex;padding-top: 15px;">
        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="passClick(0)">审核通过</el-button>
        </div>
        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="nopassClick(0)">审核不通过</el-button>
        </div>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table  size="small" :data="tableData" 
        row-key="notes_comment_id" default-expand-all @selection-change="handleSelectionChange"
        border style="width: 100%" v-loading="loading">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="notes_comment_id" label="ID" width="80">

          </el-table-column>
          <el-table-column label="动态" width="400px">
            <template slot-scope="scope">
              <div class="product-info">
                
                <div class="info" v-if="scope.row && scope.row.context">
                  <div class="namex" v-html="scope.row.context"></div>

                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="	用户">
            <template slot-scope="scope">
              <p class="ww100 text-ellipsis-2">{{scope.row.nickName}}</p>
            </template>
          </el-table-column>
  
          <el-table-column prop="content" label="评论内容" width="200">
            <template slot-scope="scope">
              <p class="ww100 text-ellipsis-2">{{scope.row.content}}</p>
            </template>
          </el-table-column>
    
          <el-table-column prop="status" label="评价状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==0" class="red fb">待审核</span>
              <span v-if="scope.row.status==1" class="green">审核通过</span>
              <span v-if="scope.row.status==2" class="gray9">审核未通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="create_time" label="评论时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 0" @click="passClick(scope.row)" type="text" size="small">审核</el-button>
              <el-button v-if="scope.row.status == 0" @click="nopassClick(scope.row)" type="text" size="small">审核不通过</el-button>
             
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/product/comment/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
   
  </div>
</template>

<script>
  import NotesApi from '@/api/notes.js';
import { isNull } from 'lodash';

  export default {
    components: {

    },
    data() {
      return {
        multipleSelection:[],
        loading: true,
        activeName: '-1',
        num: 0,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*总条数*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          score: 0,
          name: ''
        },
        /*评价等级*/
        commentList: [{
            name: '好评',
            val: 10
          },
          {
            name: '中评',
            val: 20
          },
          {
            name: '差评',
            val: 30
          },
        ],
        status: -1,
        open_add:false,
        showBack:false,
      };
    },
    created() {
      if(this.$route.query.notes_id && this.$route.query.notes_id >0){
        this.showBack = true;
        this.searchForm.name =  this.$route.query.notes_id
      }
      /*获取列表*/
      this.getData();
    },
    methods: {
      handleSelectionChange(e) {
        this.multipleSelection = e;
      },
        /*返回上一页面*/
        gotoBack(){
        this.$router.back(-1);
      },
      add(){
        this.open_add = true;
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        let Params = self.searchForm;
        self.getData(Params);
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
          /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getData();
    },
      /*获取列表*/
      getData(param = '') {
        let self = this;
        let Params = {};
        Params.status = self.status;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.name = self.searchForm.name;
        if (param != '') {
          Params.score = param.score;
        }
        NotesApi.getCommentList(Params, true).then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total
          self.num = res.data.num;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*打开编辑*/
      detailClick(row) {
        this.$router.push({
          path: '/product/comment/Detail',
          query: {
            comment_id: row.comment_id,
          }
        });
      },

      /*订单详情*/
      orderClick(row) {
        this.$router.push({
          path: '/product/comment/Order',
          query: {
            order_id: row.order_id,
          }
        });
      },

      /*删除*/
      delClick: function(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          NotesApi.delEvl({
            notes_comment_id: row.notes_comment_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.status = self.status;
        NotesApi.getCommentList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;

          self.totalDataNumber = data.data.list.total
        }).catch(error => {
          self.loading = false;
        });
      },

      /*切换选项卡*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.loading = true;
        self.status = tab.name;
        self.getData();
      },
      passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        notes_comment_id:item.notes_comment_id,
        status:1
      }
      if(!item){
        let ids = [];
        let arrray = self.multipleSelection;
        console.log(arrray);
        arrray.forEach((param) => {
          ids.push(param.notes_comment_id);
        })
        ids = ids.join(',');
        Params.notes_comment_id = ids;
        console.log(ids);
      }
      NotesApi.passCanelE(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getData();
              return false;
          }
        })
        .catch(error => {
          
         
        });

    },
    async nopassClick(item){//退款申请-不通过审核
      await this.promptInput('请输入不通过的原因', '请输入2-4个汉字',item);
    },
    async promptInput(message, validation,item) {
        let self = this;
        await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        }).then(({value}) => {
          let reject_val = value;
          if(!reject_val){
            self.$message({
              type: 'error',
              message: message,
            });
            return false;
          }
          var Params = {
            notes_comment_id:item.notes_comment_id,
            status:2,
            reject_val:reject_val
          }
          if(!item){
            let ids = [];
            let params = self.multipleSelection;
            params.forEach((param) => {
              ids.push(param.notes_comment_id);
            })
            ids = ids.join(',');
            Params.notes_comment_id = ids;
          }
          console.log("Params");
          console.log(Params);
          NotesApi.passCanelE(Params, true)
            .then(data => {
              if(data.code == 1){
                self.$message({
                    type: 'success',
                    message: '审核成功'
                });
                  self.getData();
                  return false;
              }
            })
            .catch(error => {});
          }).catch(e=>{
          // this.$message({
          //   type: 'info',
          //   message: '取消输入',
          // });
          });
    },
    }
  };
</script>

<style>
  .namex{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/notes/index/evl.vue